import designer from '../prompts/tones/designer.txt'
import engineer from '../prompts/tones/engineer.txt'

export const tonesPresets = [
  {
    id: -1,
    name: 'Engineer',
    content: engineer.trim(),
  },
  {
    id: -2,
    name: 'Designer',
    content: designer.trim(),
  },
]
